<app-docu-upsell-dialog>
  <ng-template pTemplate="title">
    Du har tyvärr använt alla dina gratis sparningar.
  </ng-template>
</app-docu-upsell-dialog>
